import React, { useState, useEffect, useRef } from "react";
import { useMutation, useManualQuery } from "graphql-hooks";
import { Helmet } from "react-helmet-async";

import {
  Box,
  Typography,
  TextField,
  Tabs,
  Tab,
  Button,
  Paper,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Switch,
  FormControlLabel,
  FormHelperText,
  Chip,
  InputBase,
  useMediaQuery,
  Radio,
  RadioGroup,
  Avatar
} from "@mui/material";
import { styled } from "@mui/material/styles";

import mascotIcon from "./assets/icons/mascotIcon.png";
import AuthWrapper from "./AuthWrapper";
import { SET_AVATAR_IMAGE_MUTATION,
         SET_COVER_IMAGE_MUTATION,
         USER_DATA_BY_UUID,
         UPDATE_PROFILE_MUTATION } from "./graphQL/user_qry";

//DatePicker

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import useIsTablet from "./hooks/useIsTablet";
import useIsMobile from "./hooks/useIsMobile";



// Material Icons
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import SettingsInputComponentIcon from '@mui/icons-material/SettingsInputComponent';
import { LocationOnOutlined } from "@mui/icons-material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CloseIcon from "@mui/icons-material/Close";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import DeleteOutline from "@mui/icons-material/DeleteOutline";

import profileBanner from "./assets/PublicPages/profile-banner.png";
import profileImage from "./assets/PublicPages/profile-image.png";
import defaultAvatar from "./assets/defaultAvatar.png";

import AlertPopup from "./components/AlertPopup";
import FloatingMenu from "./components/FloatingMenu";

const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: "none",
  "& .MuiTabs-indicator": {
    backgroundColor: "#EF5658",
  },
  "& .MuiTabs-flexContainer": {
    justifyContent: "flex-start",
    gap: "40px",
    "@media (max-width: 1360px)": {
      justifyContent: "space-between",
    },
  },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: "none",
  minWidth: "113px",
  fontWeight: 500,
  color: "#666",
  flexDirection: "row",
  "&.Mui-selected": {
    color: "#EF5658",
  },
  "& .MuiSvgIcon-root": {
    marginRight: theme.spacing(1),
    marginBottom: 0,
  },
}));

const StyledFormControl = styled(FormControl)(() => ({
  "& .MuiOutlinedInput-root": { height: "56px" },
  "& fieldset": { borderColor: "rgba(0, 0, 0, 0.23)" },
  "& .MuiInputLabel-asterisk": { color: "#ef5658 !important" },
  "& .MuiFormLabel-asterisk": { color: "#ef5658 !important" },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(0, 0, 0, 0.23)",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(0, 0, 0, 0.87)",
    borderWidth: "1px",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "rgba(0, 0, 0, 0.87)",
  },
}));

const StyledOptionalFormControl = styled(FormControl)(() => ({
  "& .MuiOutlinedInput-root": { height: "56px" },
  "& fieldset": { borderColor: "rgba(0, 0, 0, 0.23)" },
  "& .MuiInputLabel-root": { color: "black" },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(0, 0, 0, 0.23)",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(0, 0, 0, 0.87)",
    borderWidth: "1px",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "rgba(0, 0, 0, 0.87)",
  },
}));

////for header
// Styled Components
const PageContainer = styled(Box)({
  backgroundColor: "#f5f5f5",

});

const ProfileBanner = styled(Box)(({ theme }) => ({
  position: "relative",
  height: "300px",
  overflow: "hidden",
  backgroundSize: "cover",
  backgroundPosition: "center",
  borderRadius: "12px",
  marginBottom: "16px",
  [theme.breakpoints.down(1360)]: {
    height: "250px",
  },
  [theme.breakpoints.down(833)]: {
    height: "203px",
  },
}));

const MainContainer = styled(Box)(({ theme }) => ({
  margin: "0 auto",
  padding: "24px 100px 3px 100px", // bottom = 8px
  [theme.breakpoints.down(1360)]: {
    padding: "24px 16px 3px 16px", // bottom = 8px
  },
}));

const ProfileInfo = styled(Box)({
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  color: "white",
  background: "linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent)"
});

const ProfileInfoContent = styled(Box)({
  padding: "0px 20px 30px",
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "space-between",
});

const ProfileAvatar = styled(Avatar)(({ theme }) => ({
  width: 96,
  height: 96,
  [theme.breakpoints.down(833)]: {
    width: 60,
    height: 60,
  },
  border: "3px solid white",
  marginRight: "20px",
}));

const UserDetails = styled(Box)({
  flex: 1,
});

const UserStats = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  [theme.breakpoints.down(833)]: {
    display: "none",
  },
}));

const StatDivider = styled(Box)({
  width: "1px",
  height: "40px",
  backgroundColor: "white",
  opacity: 0.3,
  marginRight: "20px",
});

const MobileStatDivider = styled(Box)({
  width: "1px",
  height: "40px",
  marginRight: "25px",
  backgroundColor: "#e0e0e0",
  opacity: 0.6,
});

const StatItem = styled(Box)({
  textAlign: "center",
  paddingRight: "30px",
});

const MobileStatsContainer = styled(Box)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.down(833)]: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "20px",
    padding: "16px",
    backgroundColor: "white",
    borderRadius: "8px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  },
}));

const AvatarWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  display: "inline-block",
}));

const AvatarEditButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  bottom: -4,
  right: -4,
  backgroundColor: "white",
  width: 32,
  height: 32,
  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
  "&:hover": { backgroundColor: "#f3f3f3" },
}));



/////

// Sample user UUID
const sampleUserUuid = "9b8c0ddc-fb99-4f19-96e0-04a7aa296e76";


const TabPanel = ({ children, value, index, ...other }) => {
  return (

    <div
      role="tabpanel"
      hidden={value !== index}
      id={`edit-tabpanel-${index}`}
      aria-labelledby={`edit-tab-${index}`}
      style={{ padding: 0, margin: 0 }}     // ? KEY FIX
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0, m: 0 }}>
          {children}
        </Box>
      )}
    </div>

  );
};

const Profile = () => {

  const [activeTab, setActiveTab] = useState(0);
  //const isTablet = useIsTablet(1360); // Use 1360px breakpoint for tablet size
  //const isMobile = useIsMobile(856); // Use 856px breakpoint for mobile size

  const isMobile = useMediaQuery("(max-width:1024px)");
  const [floatMenuLeftMargin, setFloatMenuLeftMargin] = useState(0);
  let userUuid = localStorage.getItem("userUuid") ? localStorage.getItem("userUuid") : null;

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const [photoPreview, setPhotoPreview] = useState(null);
  const [photoSize, setPhotoSize] = useState("");

  const [currUsrUuid, setCurrUsrUuid] = useState(() => userUuid || sampleUserUuid);

  const [usrDataObj, setUsrDataObj] = useState({});

  const [originalFormData, setOriginalFormData] = useState({});

  const [avatarFileName, setAvatarFileName] = useState("");
  const [coverImage, setCoverImage] = useState("");


  const [formData, setFormData] = useState({});

  const fileInputAvatarRef = useRef(null);

  // Popup states
  const [showPopup, setShowPopup] = useState(false);
  const [popupConfig, setPopupConfig] = useState({
    title: "",
    message: "",
    showCheckCircle: false,
    confirmText: "Close",
    cancelText: "CANCEL",
    onConfirm: null,
  });

  // Form validation errors
  const [errors, setErrors] = useState({
    username: "",
    firstName: "",
    lastName: "",
    email: "",

  });

  const [getUsrData] = useManualQuery(USER_DATA_BY_UUID);

  useEffect(() => {
    (async () => setUserData())();
  }, []);

  useEffect(() => {
    (async () => updateOriginalFormData())();
  }, [usrDataObj]);

 useEffect(() => {
    (async () => updateFormData())();
  }, [originalFormData]);


  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen]);

  const setUserData = async () => {
    if (!currUsrUuid) return;
    const {
      loading: loadingUsrData,
      error: errorCurrUsrData,
      data: usrData,
    } = await getUsrData({
      variables: {
        uuid: currUsrUuid,
      },
    });
    if (!loadingUsrData && usrData) {
      setUsrDataObj(usrData.userDataByUuid);
      console.log("setUserData",usrData.userDataByUuid);
      if (usrDataObj)
      {
        setAvatarFileName(usrData.userDataByUuid.avatarFileName);
        setCoverImage(usrData.userDataByUuid.coverImage);
      }

    } else {
      console.log("errorCurrUsrData: ", errorCurrUsrData);
    }
  };

  const updateOriginalFormData = async () => {
    // Track original form data to detect changes
    if (usrDataObj)
     {
        setOriginalFormData({
          username: usrDataObj.username,
          firstName: usrDataObj.firstName,
          lastName: usrDataObj.lastName,
          email: usrDataObj.email,
          birthDate: usrDataObj.birthDate ? usrDataObj.birthDate.split("T")[0] : null,
          phoneNo: usrDataObj.phoneNo,
          bio: usrDataObj.bio,
          address: usrDataObj.address,
          city: usrDataObj.city,
          state: usrDataObj.state,
          country: usrDataObj.country,
          address: usrDataObj.address,
          zip: usrDataObj.zip,
          emailVisibility: usrDataObj.emailVisibility,
          phoneNoVisibility: usrDataObj.phoneNoVisibility,
          addressVisibility: usrDataObj.addressVisibility,
          autoLogin: usrDataObj.autoLogin,
          idleTime: usrDataObj.idleTime ? String(usrDataObj.idleTime) : "",
          dateJoined: dayjs(usrDataObj.date_joined),
          activationDate: dayjs(usrDataObj.activationDate),
          shipsIn: usrDataObj.shipsIn,
          userUuid: usrDataObj.userUuid,
          listings: "3456",
          followerNo: usrDataObj.followerNo,
          followingNo: usrDataObj.followingNo
        });
    }
    else
    {
      setOriginalFormData({
          username: "",
          firstName: "",
          lastName: "",
          email: "",
          birthDate: "",
          phoneNo: "",
          bio: "",
          address: "",
          city: "",
          state: "",
          country: "",
          address: "",
          zip: "",
          emailVisibility: false,
          phoneNoVisibility: false,
          addressVisibility: false,
          autoLogin: false,
          idleTime: "",
          dateJoined: "",
          activationDate: "",
          shipsIn: "",
          userUuid: "",
          listings: "3456",
          followerNo: "",
          followingNo: "",
        });
    }

   };

   const updateFormData = async () => {
     console.log("originalFormData",originalFormData);
    // Track form data to detect changes
    setFormData({
      username: originalFormData.username,
      firstName: originalFormData.firstName,
      lastName: originalFormData.lastName,
      email: originalFormData.email,
      birthDate: originalFormData.birthDate ? originalFormData.birthDate.split("T")[0] : null,
      phoneNo: originalFormData.phoneNo,
      bio: originalFormData.bio,
      address: originalFormData.address,
      city: originalFormData.city,
      state: originalFormData.state,
      country: originalFormData.country,
      address: originalFormData.address,
      zip: originalFormData.zip,
      emailVisibility: originalFormData.emailVisibility,
      phoneNoVisibility: originalFormData.phoneNoVisibility,
      addressVisibility: originalFormData.addressVisibility,
      autoLogin: originalFormData.autoLogin,
      idleTime: originalFormData.idleTime,
      dateJoined: dayjs(originalFormData.dateJoined),
      activationDate: dayjs(originalFormData.activationDate),
      shipsIn: originalFormData.shipsIn,
      userUuid: originalFormData.userUuid,
      listings: "3456",
      followerNo: originalFormData.followerNo,
      followingNo: originalFormData.followingNo
    });

   };


  // Set floating menu place based on screen size
  useEffect(() => {
    const handleResize = () => {
      setFloatMenuLeftMargin(window.innerWidth - 100);
    };

    // Set initial value
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);
  }, []);

  const getCurrentTabName = () => {
    const tabNames = [
      "Personal Info",
      "Shipping Address",
      "Preferences",
      "Notifications",
      "Other"
    ];
    return tabNames[activeTab] || "Current";
  };

  const resetCurrentTabData = () => {
    switch (activeTab) {
      case 0: // Personal Info
        setFormData({
          ...formData,
          username: originalFormData.username,
          firstName: originalFormData.firstName,
          lastName: originalFormData.lastName,
          email: originalFormData.email,
          phoneNo: originalFormData.phoneNo,
          bio: originalFormData.bio

        });
        setErrors({
          ...errors,
          username: "",
          firstName: "",
          lastName: "",
          email: "",
        });
        break;

      case 1: // Shipping Address
        setFormData({
          ...formData,
          address: originalFormData.address,
          city: originalFormData.city,
          state: originalFormData.state,
          country: originalFormData.country,
          zip: originalFormData.zip,
        });

        break;

      case 2: // Preferences
        setFormData({
          ...formData,
          emailVisibility: originalFormData.emailVisibility,
          phoneNoVisibility: originalFormData.phoneNoVisibility,
          addressVisibility: originalFormData.addressVisibility,

        });

        break;

      case 3: // Notifications
        //TBD
        break;

      case 4: // Other
        setFormData({
          ...formData,
          autoLogin: originalFormData.autoLogin,
          idleTime: originalFormData.idleTime,
        });

        setErrors({
          ...errors,
          idleTime: "",

        });
        break;

      default:
        break;
    }
  };

  const handleTabChange = (event, newValue) => {
    // If no changes, switch tab immediately
    if (!hasFormDataChanged()) {
      setActiveTab(newValue);
      return;
    }
    // If there are changes, show confirmation dialog
    setPopupConfig({
      title: `Are you sure you want to ignore the changes to ${getCurrentTabName()} tab?`,
      message: "",
      showCheckCircle: false,
      confirmText: "YES",
      cancelText: "NO",
      onConfirm: () => handleIgnoreChanges(newValue),
    });
    setShowPopup(true);
  };

  const handleIgnoreChanges = (tabValue) => {
    // Reset the current tab's data before switching
    resetCurrentTabData();

    // Switch to the new tab
    setActiveTab(tabValue);
  };

  const handleInputChange = (field) => (event) =>{
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
  };

  const handleRadioChange = (field) => (event) =>{
    setFormData({
      ...formData,
      [field]: event.target.checked,
    });
  };

  const handleBirthDateChange = (value) =>{
    console.log(value);
   let normalized = value
    ? value.toISOString().substring(0, 10)
    : null;
    console.log(normalized);
   normalized = value ? value.format("YYYY-MM-DD") : null;
   console.log(normalized);

  setFormData((prev) => ({
    ...prev,
    birthDate: normalized,
  }));
  };


  const validateCurrentTab = () => {
    const newErrors = {};
    let hasErrors = false;

    switch (activeTab) {
      case 0: // Personal Info tab
        if (!formData.username.trim()) {
          newErrors.username = "username cannot be blank.";
          hasErrors = true;
        }
        if (!formData.firstName.trim()) {
          newErrors.firstName = "First Name cannot be blank.";
          hasErrors = true;
        }
        if (!formData.lastName.trim()) {
          newErrors.lastName = "Last Name cannot be blank.";
          hasErrors = true;
        }
        if (!formData.email.trim()) {
          newErrors.email = "Email cannot be blank.";
          hasErrors = true;
        }

        break;

      case 4: // Other
        const idleTimeStr = String(formData.idleTime || "").trim();

        if (!idleTimeStr) {
          newErrors.idleTime = "idleTime cannot be blank.";
          hasErrors = true;
        }

        break;

      default:
        break;
    }

    setErrors(newErrors);
    return !hasErrors;
  };

  const handleSave = () => {
    if (validateCurrentTab()) {
      // Only show save confirmation if there are changes
      if (hasFormDataChanged()) {
        setPopupConfig({
            title: `Are you sure you want to save the changes to ${getCurrentTabName()} tab?`,
            message: "",
            showCheckCircle: true,
            confirmText: "SAVE",
            cancelText: "CANCEL",
            onConfirm: handleConfirmSave,
          });
        setShowPopup(true);
      } else {
        //No changes to save
        setPopupConfig({
          title: `You did not make any changes.`,
          message: "",
          showCheckCircle: false,
          confirmText: "OK",
          cancelText: null,
          onConfirm: null,
        });
        setShowPopup(true);
      }
    } else {
      // Show error popup for first empty required field on current tab
      const firstError = Object.values(errors).find((error) => error);
      if (firstError) {
        setPopupConfig({
          title: `Error in ${getCurrentTabName()} tab`,
          message: firstError,
          showCheckCircle: false,
          confirmText: "CLOSE",
          cancelText: "CANCEL",
          onConfirm: null,
        });
        setShowPopup(true);
      }
    }
  };

  const addTimeStampToFilename = (fileName) => {
    const ext = fileName.substring(fileName.lastIndexOf("."));
    const name = fileName.substring(0, fileName.lastIndexOf("."));
    const timestamp = Date.now();
    return `${name}_${timestamp}${ext}`;
  };

  const [updateProfile] = useMutation(UPDATE_PROFILE_MUTATION);
  const handleConfirmSave = async() => {
    console.log("Saving data:", formData);

    // Update original data to current data after successful save
    setOriginalFormData({ ...formData });

    //saving data to database
    const { data, error } = await updateProfile({
          variables: {
            inputData: formData
          }
      });
    if (error) {
        console.log("Error", error, data);
        //setErrorMsg(error.graphQLErrors[0].message);
    } else {
        //setAlertMsg({
          //title: "Success",
          //msg: "New Password was changed successfully.",
        //});
        console.log("Success");
      }
  };

  const handleCancel = () => {
    if (!hasFormDataChanged()) {
      console.log("Cancelled - no changes to discard");
      return;
    }

    // If there are changes, show confirmation dialog
    setPopupConfig({
      title: `Are you sure you want to ignore the changes to ${getCurrentTabName()} tab?`,
      message: "",
      showCheckCircle: false,
      confirmText: "YES",
      cancelText: "NO",
      onConfirm: handleConfirmCancel,
    });
    setShowPopup(true);
  };

  const handleConfirmCancel = () => {
    console.log("Cancelled - discarding changes for current tab");

    // Reset the current tab's data
    resetCurrentTabData();

    // Close popup
    setShowPopup(false);
  };

  const handleCoverUploadClick = () => {
    document.getElementById("cover-upload").click();
  };
  const [updateCoverImage] = useMutation(SET_COVER_IMAGE_MUTATION);
  const handleCoverUpload = async(event) => {
    const file = event.target.files[0];
    if (file){
      const previewUrl = URL.createObjectURL(file);
      setCoverImage(previewUrl);

      const { data, error } = await updateCoverImage({
          variables: {
            coverImageFile: file,
            coverImage: addTimeStampToFilename(file.name)
          }
      });
      if (error) {
        console.log("Error", error, data);
      } else {
        console.log("Success");
      }
    }
  };

  const handleAvatarEditClick = () => {
   fileInputAvatarRef.current?.click();
  };

  const [updateAvatarImage] = useMutation(SET_AVATAR_IMAGE_MUTATION);
  const handleAvatarFileChange = async(event) => {
    const file = event.target.files[0];
    if (file) {
      const newImgUrl = URL.createObjectURL(file);
      setAvatarFileName(newImgUrl)
      // Calculate file size in KB
      const sizeInKB = (file.size / 1024).toFixed(0);
      setPhotoSize(`${sizeInKB}KB`);

      const reader = new FileReader();
      reader.onloadend = () => {
        setPhotoPreview(reader.result);
      };
      reader.readAsDataURL(file);

      const { data, error } = await updateAvatarImage({
          variables: {
            avatarFile: file,
            avatarFileName: addTimeStampToFilename(file.name)
          }
      });
      if (error) {
        console.log("Error", error, data);
      } else {
        console.log("Success");
      }
    }
  };

  const handleRemovePhoto = () => {
    setFormData({
      ...formData,
      avatarFileName: "",
      avatarFile: null,
    });
    setPhotoPreview(null);
    setPhotoSize("");
    setAvatarFileName("");
    // Reset file input
    const fileInput = document.getElementById("photo-upload");
    if (fileInput) {
      fileInput.value = "";
    }
  };

// Tab options for mobile dropdown
  const tabOptions = [
    { value: 0, label: "Personal Info", icon: <PersonOutlineIcon /> },
    { value: 1, label: "Shipping Address", icon: <LocationOnOutlinedIcon /> },
    { value: 2, label: "Preferences", icon: <MiscellaneousServicesIcon /> },
    { value: 3, label: "Notifications", icon: <NotificationsNoneIcon /> },
    { value: 4, label: "Other", icon: <SettingsInputComponentIcon /> }
  ];

  // Check if form data has changed
  const hasFormDataChanged = () => {
    const formChanged =
      JSON.stringify(formData) !== JSON.stringify(originalFormData);

    return formChanged ;
  };

  return (
  <AuthWrapper>
    <Helmet>
        <title>R3PLAY - My Profile</title>
        <meta
          name="description"
          content="Update your profile's information, cover image and avatar on R3PLAY."
        />
        <meta
          property="keywords"
          content="Edit profile, update profile, profile management"
        />
      </Helmet>

    <PageContainer sx={{ paddingBottom: isMobile ?  5 : 0}}>
      {/* Header with Profile Banner */}
      <MainContainer >
        <ProfileBanner
          sx={{
            backgroundImage: `url(${coverImage})`,
          }}
        >
          {/* Change Cover Button */}
          <Box sx={{ position: "absolute", top: 20, right: 20 }}>
            <Button
              variant="outlined"
              startIcon={
                <ImageOutlinedIcon
                  sx={{
                    fontSize: 18,
                    color: "#fff",
                  }}
                />
              }
              sx={{
                color: "#fff",            // White text
                borderColor: "rgba(255,255,255,0.8)",
                textTransform: "none",
                borderRadius: "8px",
                padding: "5px 14px",
                fontSize: "14px",
                fontWeight: 500,
                backgroundColor: "transparent !important",   // No background
                backdropFilter: "none",                       // No blur
                "& .MuiButton-startIcon": {
                  marginRight: "6px",                         // Tight like Figma
                },
                "&:hover": {
                  borderColor: "#fff",
                  backgroundColor: "rgba(255,255,255,0.10)",  // Just slight hover feedback
                },
              }}
              onClick={handleCoverUploadClick}
            >
              Change Cover
            </Button>

            {/* Hidden uploader */}

            <input
                type="file"
                id="cover-upload"
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleCoverUpload}
              />
          </Box>


          <ProfileInfo>
            <ProfileInfoContent>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>

                {/* ProfileAvatar */}
                <Box sx={{ position: "relative", display: "inline-block" }}>
                  <ProfileAvatar src={avatarFileName} alt="Profile" />

                  {/* Edit Button */}
                  <IconButton
                    component="label"
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      right: 15,
                      width: 25,
                      height: 25,
                      backgroundColor: "white",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                      "&:hover": { backgroundColor: "#f0f0f0" },
                    }}
                  >
                    <PhotoCamera sx={{ fontSize: 18 }} />
                    <input type="file" hidden onChange={handleAvatarFileChange} />
                  </IconButton>
                </Box>


                <UserDetails>
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: "bold",
                      mb: 0.5,
                      "@media (max-width: 833px)": {
                        fontSize: "16px",
                      },
                    }}
                  >
                    {formData.firstName + " " + formData.lastName}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      mb: 1,
                      "@media (max-width: 833px)": {
                        fontSize: "12px",
                      },
                    }}
                  >
                    @{formData.username}
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <LocationOnOutlined sx={{ fontSize: 16 }} />
                    <Typography variant="caption">
                      {formData.state + " " + formData.country}
                    </Typography>
                  </Box>
                </UserDetails>
              </Box>
              <UserStats>
                <StatItem sx={{ paddingRight: "20px" }}>
                  <Typography variant="h6" sx={{ fontWeight: "semibold" }}>
                    {formData.listings}
                  </Typography>
                  <Typography variant="caption" sx={{ opacity: 0.8 }}>
                    Listings
                  </Typography>
                </StatItem>
                <StatDivider />
                <StatItem>
                  <Typography variant="h6" sx={{ fontWeight: "semibold" }}>
                    {Number(formData.followerNo).toLocaleString()}
                  </Typography>
                  <Typography variant="caption" sx={{ opacity: 0.8 }}>
                    Followers
                  </Typography>
                </StatItem>
                <StatItem>
                  <Typography variant="h6" sx={{ fontWeight: "semibold" }}>
                    {Number(formData.followingNo).toLocaleString()}
                  </Typography>
                  <Typography variant="caption" sx={{ opacity: 0.8 }}>
                    Following
                  </Typography>
                </StatItem>
              </UserStats>
            </ProfileInfoContent>
          </ProfileInfo>
        </ProfileBanner>

        {/* Mobile Stats - Only visible on mobile (833px and below) */}
        <MobileStatsContainer>
          <StatItem sx={{ paddingLeft: "18px" }}>
            <Typography variant="h6" sx={{ fontWeight: "semibold" }}>
              {formData.listings}
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.8 }}>
              Listings
            </Typography>
          </StatItem>
          <MobileStatDivider />
          <StatItem>
            <Typography variant="h6" sx={{ fontWeight: "semibold" }}>
              {Number(formData.followerNo).toLocaleString()}
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.8 }}>
              Followers
            </Typography>
          </StatItem>
          <MobileStatDivider />
          <StatItem>
            <Typography variant="h6" sx={{ fontWeight: "semibold" }}>
              {Number(formData.followingNo).toLocaleString()}
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.8 }}>
              Following
            </Typography>
          </StatItem>
        </MobileStatsContainer>

      </MainContainer>

    {/* End */}

     <Box
      sx={{
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
        px: "100px",
        "@media (max-width: 1360px)": {
          px: "16px",
        },
      }}
    >

      {/* Tab Box - Desktop - Tablet */}
      {!isMobile && (
        <Paper
          sx={{
            backgroundColor: "white",
            borderRadius: "12px",
            height: "68px",
            p: "16px",
            mb: 2,
            display: "flex",
            alignItems: "center",
          }}
        >
          <StyledTabs
            value={activeTab}
            onChange={handleTabChange}
            centered
            sx={{ width: "100%" }}
          >
            <StyledTab icon={<PersonOutlineIcon />} label="Personal Info" />
            <StyledTab icon={<LocationOnOutlinedIcon />} label="Shipping Address" />
            <StyledTab icon={<MiscellaneousServicesIcon />} label="Preferences" />
            <StyledTab
              icon={<NotificationsNoneIcon />}
              label="Notifications"
            />
            <StyledTab icon={<SettingsInputComponentIcon />} label="Other" />
          </StyledTabs>
        </Paper>
      )}

      {/* Tab Dropdown - Mobile */}
      {isMobile && (
        <Paper
          sx={{
            backgroundColor: "white",
            borderRadius: "12px",
            p: "16px",
            mb: 2,
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <FormControl sx={{ minWidth: 200 }}>
            <Select
              value={activeTab}
              onChange={(e) => handleTabChange(e, e.target.value)}
              displayEmpty
              sx={{
                height: "40px",
                "& .MuiSelect-select": {
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                },
                "&:hover": {
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(0, 0, 0, 0.23)",
                  },
                },
                "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(0, 0, 0, 0.23)",
                },
                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(0, 0, 0, 0.23)",
                  borderWidth: "1px",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(0, 0, 0, 0.23)",
                  borderWidth: "1px",
                },
              }}
            >
              {tabOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {option.icon}
                    {option.label}
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Paper>
      )}

      {/* Content Space */}

      {/* Personal Information tab */}
      <TabPanel value={activeTab} index={0}>
        <Paper sx={{ backgroundColor: "white", borderRadius: "12px", p: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            <PersonOutlineIcon sx={{ color: "#EF5658", mr: 1 }} />
            <Typography variant="h6" sx={{ fontWeight: 500 }}>
              Personal Information{" "}

            </Typography>
          </Box>
          {/* Row 1: username */}
          <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
              <TextField
                fullWidth
                label="User Name"
                InputLabelProps={{ shrink: true }}
                placeholder={formData.username ? "" : "Enter User Name"}
                variant="outlined"
                required
                error={!!errors.username}
                helperText={errors.username}
                sx={{

                  "& .MuiInputBase-root": { height: "56px" },
                }}
                value={formData.username}
                onChange={handleInputChange("username")}
              />
          </Box>

          {!isMobile ?
            (
             <>
                {/* Row 2: First + Last Name */}
                <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
                  <TextField
                    fullWidth
                    label="First Name"
                    InputLabelProps={{ shrink: true }}
                    placeholder={formData.firstName ? "" : "Enter First Nname"}
                    error={!!errors.firstName}
                    helperText={errors.firstName}
                    sx={{ "& .MuiInputBase-root": { height: "56px" } }}
                    value={formData.firstName}
                    onChange={handleInputChange("firstName")}
                  />

                  <TextField
                    fullWidth
                    label="Last Name"
                    InputLabelProps={{ shrink: true }}
                    placeholder={formData.lastName ? "" : "Enter Last Name"}
                    error={!!errors.lastName}
                    helperText={errors.lastName}
                    sx={{ "& .MuiInputBase-root": { height: "56px" } }}
                    value={formData.lastName}
                    onChange={handleInputChange("lastName")}
                  />
                </Box>

              {/* Row 3: Email + birthDate + PhoneNo  */}
                <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
                  <TextField
                    fullWidth
                    label="Email Address"
                    InputLabelProps={{ shrink: true }}
                    placeholder={formData.email ? "" : "Enter Email"}
                    type="email"
                    error={!!errors.email}
                    helperText={errors.email}
                    value={formData.email}
                    onChange={handleInputChange("email")}

                    sx={{ "& .MuiInputBase-root": { height: "56px" } }}
                  />

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            slotProps={{
                                textField: {
                                  fullWidth: true,
                                  required: true,

                                },

                            actionBar: {
                              actions: ["cancel", "accept"],
                            },
                          }}
                          value={formData.birthDate ? dayjs(formData.birthDate) : null}
                          label="Birth Date"
                          onChange={(newValue) => handleBirthDateChange(newValue)}
                          views={["year", "month", "day"]}
                        />
                </LocalizationProvider>


                  <TextField
                    fullWidth
                    label="Phone No"
                    placeholder={formData.phoneNo ? "" : "Enter Phone Number"}
                    InputLabelProps={{ shrink: true }}
                    sx={{ "& .MuiInputBase-root": { height: "56px" } }}
                    value={formData.phoneNo}
                    onChange={handleInputChange("phoneNo")}
                  />

                </Box>
              </>
            ) : (
            <>
            {/* Row 2: First Name */}
                <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
                  <TextField
                    fullWidth
                    label="First Name"
                    InputLabelProps={{ shrink: true }}
                    placeholder={formData.firstName ? "" : "Enter First Nname"}
                    error={!!errors.firstName}
                    helperText={errors.firstName}
                    sx={{ "& .MuiInputBase-root": { height: "56px" } }}
                    value={formData.firstName}
                    onChange={handleInputChange("firstName")}
                  />

                </Box>

              {/* Row 3: Last Name */}
                <Box sx={{ display: "flex", gap: 2, mb: 3 }}>

                  <TextField
                    fullWidth
                    label="Last Name"
                    InputLabelProps={{ shrink: true }}
                    placeholder={formData.lastName ? "" : "Enter Last Name"}
                    error={!!errors.lastName}
                    helperText={errors.lastName}
                    sx={{ "& .MuiInputBase-root": { height: "56px" } }}
                    value={formData.lastName}
                    onChange={handleInputChange("lastName")}
                  />
                </Box>


              {/* Row 4: Email */}
                <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
                  <TextField
                    fullWidth
                    label="Email Address"
                    InputLabelProps={{ shrink: true }}
                    placeholder={formData.email ? "" : "Enter Email"}
                    type="email"
                    error={!!errors.email}
                    helperText={errors.email}
                    value={formData.email}
                    onChange={handleInputChange("email")}

                    sx={{ "& .MuiInputBase-root": { height: "56px" } }}
                  />

                </Box>

              {/* Row 5: birthDate   */}
                <Box sx={{ display: "flex", gap: 2, mb: 3 }}>

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            slotProps={{
                                textField: {
                                  fullWidth: true,
                                  required: true,

                                },

                            actionBar: {
                              actions: ["cancel", "accept"],
                            },
                          }}
                          value={formData.birthDate ? dayjs(formData.birthDate) : null}
                          label="Birth Date"
                          onChange={(newValue) => handleBirthDateChange(newValue)}
                          views={["year", "month", "day"]}
                        />
                  </LocalizationProvider>
                </Box>

            {/* Row 6: PhoneNo  */}
                <Box sx={{ display: "flex", gap: 2, mb: 3 }}>

                  <TextField
                    fullWidth
                    label="Phone No"
                    placeholder={formData.phoneNo ? "" : "Enter Phone Number"}
                    InputLabelProps={{ shrink: true }}
                    sx={{ "& .MuiInputBase-root": { height: "56px" } }}
                    value={formData.phoneNo}
                    onChange={handleInputChange("phoneNo")}
                  />

                </Box>
            </>
            )}

          {/* Bio */}
          <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
            <TextField
              fullWidth
              label="Bio"
              InputLabelProps={{ shrink: true }}
              placeholder={formData.bio ? "" : "Enter Bio"}
              multiline
              minRows={3}
              maxRows={6}
              value={formData.bio}
              onChange={handleInputChange("bio")}
            />
          </Box>


          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 2,
              mt: 3,
            }}
          >
            <Button
              onClick={handleSave}
              variant="contained"
              sx={{
                backgroundColor: "#EF5658",
                color: "white",
                borderRadius: "4px",
                py: 1.5,
                height: "36px",
                fontSize: "14px",
                fontWeight: "medium",
                textTransform: "uppercase",
                minWidth: "140px",
                "&:hover": {
                  backgroundColor: "#D33338",
                },
              }}
            >
              Save
            </Button>
            <Button
              onClick={handleCancel}
              variant="outlined"
              sx={{
                borderColor: "#666",
                color: "#666",
                borderRadius: "4px",
                px: 3,
                py: 1.5,
                fontSize: "14px",
                fontWeight: "medium",
                height: "36px",
                textTransform: "uppercase",
                maxWidth: "140px",
                "&:hover": {
                  borderColor: "#666",
                  backgroundColor: "rgba(0,0,0,0.04)",
                },
              }}
            >
              Cancel
            </Button>
          </Box>
        </Paper>
      </TabPanel>

       {/* Shipping Address tab */}

      <TabPanel value={activeTab} index={1}>
        <Paper sx={{ backgroundColor: "white", borderRadius: "12px", p: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            <PersonOutlineIcon sx={{ color: "#EF5658", mr: 1 }} />
            <Typography variant="h6" sx={{ fontWeight: 500 }}>
              Shipping Address{" "}

            </Typography>
          </Box>
          {/* Row 1: address */}
          <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
              <TextField
                fullWidth
                label="Street Address"
                placeholder={formData.address ? "" : "Enter Street Address"}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                sx={{

                  "& .MuiInputBase-root": { height: "56px" },
                }}
                value={formData.address}
                onChange={handleInputChange("address")}
              />
          </Box>

        {/* Row 2: city */}
          <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
              <TextField
                fullWidth
                label="City"
                placeholder={formData.city ? "" : "Enter City"}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                sx={{

                  "& .MuiInputBase-root": { height: "56px" },
                }}
                value={formData.city}
                onChange={handleInputChange("city")}
              />
          </Box>

        {/* Row 3: state */}
          <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
              <TextField
                fullWidth
                label="State"
                placeholder={formData.state ? "" : "Enter State"}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                sx={{

                  "& .MuiInputBase-root": { height: "56px" },
                }}
                value={formData.state}
                onChange={handleInputChange("state")}
              />
          </Box>

          {/* Row 3: zip */}
          <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
              <TextField
                fullWidth
                label="Zip"
                placeholder={formData.zip ? "" : "Enter ZIP"}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                sx={{

                  "& .MuiInputBase-root": { height: "56px" },
                }}
                value={formData.zip}
                onChange={handleInputChange("zip")}
              />
          </Box>

          {/* Row 3: country */}
          <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
              <TextField
                fullWidth
                label="Country"
                placeholder={formData.country ? "" : "Enter Country"}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                sx={{

                  "& .MuiInputBase-root": { height: "56px" },
                }}
                value={formData.country}
                onChange={handleInputChange("country")}
              />
          </Box>

          <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 2,
                  mt: 3,
                }}
              >
                <Button
                  onClick={handleSave}
                  variant="contained"
                  sx={{
                    backgroundColor: "#EF5658",
                    color: "white",
                    borderRadius: "4px",
                    py: 1.5,
                    height: "36px",
                    fontSize: "14px",
                    fontWeight: "medium",
                    textTransform: "uppercase",
                    minWidth: "140px",
                    "&:hover": {
                      backgroundColor: "#D33338",
                    },
                  }}
                >
                  Save
                </Button>
                <Button
                  onClick={handleCancel}
                  variant="outlined"
                  sx={{
                    borderColor: "#666",
                    color: "#666",
                    borderRadius: "4px",
                    px: 3,
                    py: 1.5,
                    fontSize: "14px",
                    fontWeight: "medium",
                    height: "36px",
                    textTransform: "uppercase",
                    maxWidth: "140px",
                    "&:hover": {
                      borderColor: "#666",
                      backgroundColor: "rgba(0,0,0,0.04)",
                    },
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </Paper>
          </TabPanel>


          {/* Preferences tab */}
          <TabPanel value={activeTab} index={2}>
            <Paper sx={{ backgroundColor: "white", borderRadius: "12px", p: 3 }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <MiscellaneousServicesIcon sx={{ color: "#EF5658", mr: 1 }} />
                <Typography variant="h6" sx={{ fontWeight: 500 }}>
                  Preferences
                </Typography>
              </Box>

              {/* Row 1: text */}
               <Box sx={{  pt: 2,
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 3,
                          gap: 4
                        }}>

                  <Typography  variant="body1" sx={{ fontSize: "16px",fontWeight: 400,
                                     fontFamily: "Roboto, Helvetica, Arial, sans-serif"}}>
                    Customize your profile visibility settings.
                    You can choose to show or hide your Email Address, Phone Number, or
                    Street Address based on your comfort level.
                  </Typography>
              </Box>

            {/* Row 2: Email Address, Phone No, Street Address visibility*/}
              <Box
                  sx={{
                    display: "flex",
                    gap: 4,
                    mb: 3,
                    flexDirection: isMobile ? "column" : "row",
                  }}
                >
                  {[
                    { key: "email", label: "Email Address" },
                    { key: "phoneNo", label: "Phone No" },
                    { key: "address", label: "Street Address" },
                  ].map((item) => (
                    <Box
                      key={item.key}
                      sx={{
                        flex: {
                          xs: "1 1 100%",  // mobile: full width
                          sm: "1 1 250px", // tablet+: flexible width
                        },
                        minWidth: { xs: "100%", sm: 200 },
                      }}
                    >
                      <Typography variant="body2" sx={{ mb: 1, fontSize: "16px" }}>
                        {item.label}
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Typography variant="body1">No</Typography>
                        <Switch
                          checked={formData[`${item.key}Visibility`]}
                          onChange={handleRadioChange(`${item.key}Visibility`)}
                          sx={{
                            "& .MuiSwitch-switchBase.Mui-checked": {
                              color: "#EF5658",
                            },
                            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                              backgroundColor: "#EF5658",
                            },
                          }}
                        />
                        <Typography variant="body1">Yes</Typography>
                      </Box>
                      {formData[`${item.key}Visibility`] && (
                        <Typography
                          variant="body2"
                          sx={{ mb: 1, fontSize: "16px", color: "gray" }}
                        >
                          {formData[item.key]}
                        </Typography>
                      )}
                    </Box>
                  ))}
                </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 2,
                  mt: 3,
                }}
              >
                <Button
                  onClick={handleSave}
                  variant="contained"
                  sx={{
                    backgroundColor: "#EF5658",
                    color: "white",
                    borderRadius: "4px",
                    py: 1.5,
                    height: "36px",
                    fontSize: "14px",
                    fontWeight: "medium",
                    textTransform: "uppercase",
                    minWidth: "140px",
                    "&:hover": {
                      backgroundColor: "#D33338",
                    },
                  }}
                >
                  Save
                </Button>
                <Button
                  onClick={handleCancel}
                  variant="outlined"
                  sx={{
                    borderColor: "#666",
                    color: "#666",
                    borderRadius: "4px",
                    px: 3,
                    py: 1.5,
                    fontSize: "14px",
                    fontWeight: "medium",
                    height: "36px",
                    textTransform: "uppercase",
                    maxWidth: "140px",
                    "&:hover": {
                      borderColor: "#666",
                      backgroundColor: "rgba(0,0,0,0.04)",
                    },
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </Paper>
          </TabPanel>

      <TabPanel value={activeTab} index={3}>
        <Paper sx={{ backgroundColor: "white", borderRadius: "12px", p: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <NotificationsNoneIcon sx={{ color: "#EF5658", mr: 1 }} />
            <Typography variant="h6" sx={{ fontWeight: 500 }}>
              Notifications

            </Typography>
          </Box>

          <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",   // <-- centers horizontally
                mb: 2,
                width: "100%",              // <-- ensures full width so centering works
              }}
            >

            <Typography variant="h3" sx={{ fontWeight: 500 }}>
              TBD

            </Typography>
          </Box>

        </Paper>
      </TabPanel>

      <TabPanel value={activeTab} index={4}>
        <Paper sx={{ backgroundColor: "white", borderRadius: "12px", p: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <SettingsInputComponentIcon sx={{ color: "#EF5658", mr: 1 }} />
            <Typography variant="h6" sx={{ fontWeight: 500 }}>
              Other

            </Typography>
          </Box>

          {/* Row 1: Auto Login */}
              <Box sx={{  pt: 2,
                          display: "flex",
                          justifyContent: "space-between",
                          width: "900px", mb: 3,
                          gap: 4
                        }}>

              {/* Auto Login Switch */}
                <Box>
                  <Typography variant="body2" sx={{ mb: 1, fontSize: "16px" }}>
                    Auto Login
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography variant="body1">No</Typography>
                    <Switch
                      checked={formData.autoLogin}
                      onChange={handleRadioChange("autoLogin")}
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: "#EF5658",
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                          backgroundColor: "#EF5658",
                        },
                      }}
                    />
                    <Typography variant="body1">Yes</Typography>
                  </Box>
              </Box>

            </Box>

          {/* Row 2: idleTime */}
          <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
              <TextField
                fullWidth
                label="IdleTime"
                placeholder={formData.idleTime ? "" : "Enter IdleTime"}
                variant="outlined"
                error={!!errors.idleTime}
                helperText={errors.idleTime}
                InputLabelProps={{ shrink: true }}
                sx={{

                  "& .MuiInputBase-root": { height: "56px" },
                }}
                defaultValue={formData.idleTime}
                onChange={handleInputChange("idleTime")}
              />
          </Box>

          {/* Row 3: Joined + Activated Date */}
          <Box sx={{ display: "flex", gap: 2, mb: 3 }}>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                      disabled
                      slotProps={{
                          textField: {
                            fullWidth: true,
                            required: true,

                          },

                      actionBar: {
                        actions: ["cancel", "accept"],
                      },
                    }}
                    value={formData.dateJoined}
                    label="Date Joined"
                    views={["year", "month", "day"]}
                  />
          </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                      disabled
                      slotProps={{
                          textField: {
                            fullWidth: true,
                            required: true,

                          },

                      actionBar: {
                        actions: ["cancel", "accept"],
                      },
                    }}
                    value={formData.activationDate}
                    label="Date Activated"
                    views={["year", "month", "day"]}
                  />
          </LocalizationProvider>

          </Box>

          {/* Row 4: Ships In */}
          <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
              <TextField
                disabled
                fullWidth
                label="Ships in (Days)"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                sx={{

                  "& .MuiInputBase-root": { height: "56px" },
                }}
                defaultValue={formData.shipsIn}
              />
          </Box>

          {/* Row 5: UUID */}
          <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
              <TextField
                disabled
                fullWidth
                label="UUID"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                sx={{

                  "& .MuiInputBase-root": { height: "56px" },
                }}
                defaultValue={formData.userUuid}
              />
          </Box>


            <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 2,
                  mt: 3,
                }}
              >
                <Button
                  onClick={handleSave}
                  variant="contained"
                  sx={{
                    backgroundColor: "#EF5658",
                    color: "white",
                    borderRadius: "4px",
                    py: 1.5,
                    height: "36px",
                    fontSize: "14px",
                    fontWeight: "medium",
                    textTransform: "uppercase",
                    minWidth: "140px",
                    "&:hover": {
                      backgroundColor: "#D33338",
                    },
                  }}
                >
                  Save
                </Button>
                <Button
                  onClick={handleCancel}
                  variant="outlined"
                  sx={{
                    borderColor: "#666",
                    color: "#666",
                    borderRadius: "4px",
                    px: 3,
                    py: 1.5,
                    fontSize: "14px",
                    fontWeight: "medium",
                    height: "36px",
                    textTransform: "uppercase",
                    maxWidth: "140px",
                    "&:hover": {
                      borderColor: "#666",
                      backgroundColor: "rgba(0,0,0,0.04)",
                    },
                  }}
                >
                  Cancel
                </Button>
              </Box>

        </Paper>
      </TabPanel>


      <AlertPopup
        open={showPopup}
        onClose={() => setShowPopup(false)}
        title={popupConfig.title}
        message={popupConfig.message}
        showCheckCircle={popupConfig.showCheckCircle}
        confirmText={popupConfig.confirmText}
        cancelText={popupConfig.cancelText}
        onConfirm={popupConfig.onConfirm}
      />

      <FloatingMenu left={floatMenuLeftMargin} />

    </Box>
    </PageContainer>
  </AuthWrapper>
  );
};

export default Profile;
